import React, {
  ReactElement,
  useEffect,
  useState,
  useCallback,
} from 'react';
import { SchemaWithClient } from '../../types/SchemaWithClient';
import { Entity } from '../../types/entities/Entity';
import {
  Button,
  Button as MUIButton,
  Skeleton,
  Stack,
} from '@mui/material';
import { toaster } from '../../services/toaster';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { SlidingPaneEdit } from '../Page/SlidingPaneEdit';
import api from '../../services/api';
import { debounce } from 'lodash';
import { address } from '../../schema/address';
import { SlidingPaneAddNew } from '../Page/SlidingPaneAddNew';
import { serviceProviderVenue } from '../../schema/serviceProviderVenue';
import { serviceProvider } from '../../schema/serviceProvider';
import { MoreOptions } from '../Table/assets/MoreOptions';
import { MapGoogle } from '../Map/MapGoogle';

type Props<T extends Entity> = {
  schema: SchemaWithClient<T>;
};

export const ServiceProviderVenues = ({
  schema,
  values,
  tableType,
}: {
  schema: any;
  values: any;
  tableType: string;
}): ReactElement => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState<any>(false);
  const [properties, setProperties] = useState<any>([]);
  const [venueAddress, setVenueAddress] = useState<any>(undefined);
  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [currentAddNewPaneEntity, setCurrentAddNewPaneEntity] = React.useState<
    any
  >({
    schema: schema,
    row: {},
  });

  const debouncedOnChange = debounce(handleDebouncedOnChange, 500);
  function handleDebouncedOnChange(address: string, value: any) {
    handleChange(address, value);
  }

  const fetchVenues = useCallback(() => {
    const searchParams = new URLSearchParams({
      service_provider: values?.id,
    });

    api.get('/service-provider-venues', searchParams).then((res: any) => {
      console.log(res);

      setProperties(res);
    });
  }, []);

  const handleChange = useCallback(
    async (item: any, data: any) => {
      address.client
        .update(item?.id, data)
        .then((res: any) => {
          /* const oldProperties = [...properties];
          const newRows = oldProperties.map((row: any) => {
            return row.id === image.id ? res : row;
          });
          setProperties(newRows);*/
        })
        .catch((e: any) => {
          console.error(e);
        });
    },
    [properties]
  );

  useEffect(() => {
    fetchVenues();
  }, []);

  return (
    <>
      <Stack width={'50%'}>
        <Stack direction={'row'}>
          <Button
            sx={{
              marginY: '20px',
            }}
            variant="contained"
            onClick={() => {
              setCurrentAddNewPaneEntity({
                row: {
                  id: 'new',
                  service_provider: {
                    id: values?.id,
                    name: values?.name,
                  },
                },
                schema: serviceProviderVenue,
              });
            }}
          >
            Add New Venue
          </Button>
        </Stack>
      </Stack>

      {loading ? (
        <>
          <Skeleton
            sx={{
              mt: '20px',
            }}
            variant="rounded"
            width={'100%'}
            height={350}
          />
        </>
      ) : (
        <>
          {properties.map((venueItem: any) => {
            return (
              <Stack
                component="section"
                direction={'row'}
                sx={{
                  p: '20px',
                  background: '#dfdfdf',
                  borderRadius: '10px',
                  mt: '20px',
                  width: '100%',
                }}
              >
                <Stack width={'100%'}>
                  <Stack
                    direction={'row'}
                    gap={0}
                    sx={{
                      '& > span': {
                        border: '1px solid #cdcdcd',
                        background: '#fff',
                      },
                    }}
                  >
                    <span className={'min-w-[150px] p-[6px]'}>Name:</span>
                    <span className={'w-full p-[6px]'}>{venueItem?.name}</span>
                  </Stack>
                  <Stack
                    direction={'row'}
                    gap={0}
                    mt={'10px'}
                    sx={{
                      '& > span': {
                        border: '1px solid #cdcdcd',
                        background: '#fff',
                      },
                    }}
                  >
                    <span className={'min-w-[150px] p-[6px]'}>Address:</span>
                    <span className={'w-full p-[6px]'}>
                      {venueItem?.address_line1}
                    </span>
                  </Stack>
                  <Stack
                    direction={'row'}
                    gap={0}
                    mt={'10px'}
                    sx={{
                      '& > span': {
                        border: '1px solid #cdcdcd',
                        background: '#fff',
                      },
                    }}
                  >
                    <span className={'min-w-[150px] p-[6px]'}>
                      Coordinates:
                    </span>
                    <span className={'w-full p-[6px]'}>
                      {venueItem?.coordinates}
                    </span>
                  </Stack>

                  <Stack mt={'20px'}>
                    <MapGoogle coordinates={[]} address={venueItem} />
                  </Stack>
                </Stack>

                <Stack>
                  <MoreOptions
                    clickOnEdit={() => {
                      setOpenedSlidingPane({
                        schema: serviceProviderVenue,
                        row: venueItem,
                      });
                    }}
                    clickOnDelete={() => {
                      setOpenConfirmDialog({
                        schema: serviceProviderVenue,
                        row: venueItem,
                      });
                    }}
                  />
                </Stack>
              </Stack>
            );
          })}
        </>
      )}

      {currentAddNewPaneEntity?.row?.id && (
        <>
          <SlidingPaneAddNew
            schema={currentAddNewPaneEntity?.schema}
            mainSchema={serviceProvider}
            id={currentAddNewPaneEntity?.row?.id}
            hasSlidingPane={false}
            onSubmit={(result: any) => {
              fetchVenues();
              setCurrentAddNewPaneEntity({
                schema: schema,
                row: {},
                key: undefined,
              });
            }}
            propertiesFromTable={
              currentAddNewPaneEntity?.row ? currentAddNewPaneEntity?.row : {}
            }
            row={
              currentAddNewPaneEntity?.row ? currentAddNewPaneEntity?.row : {}
            }
            onClose={(value) => {
              fetchVenues();
              setCurrentAddNewPaneEntity({
                schema: schema,
                row: {},
                key: undefined,
              });
            }}
          />
        </>
      )}

      <Dialog
        open={openConfirmDialog}
        onClose={() => {
          setOpenConfirmDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Are you sure you want to delete it?'}
        </DialogTitle>
        <DialogActions>
          <MUIButton
            onClick={() => {
              setOpenConfirmDialog(false);
            }}
          >
            Cancel
          </MUIButton>
          <MUIButton
            variant={'contained'}
            color={'error'}
            onClick={() => {
              const deletedRow = openConfirmDialog?.row;

              openConfirmDialog?.schema.client
                .delete(deletedRow.id as number, { id: deletedRow.id })
                .then((res: any) => {
                  fetchVenues();
                  toaster.show({
                    intent: 'success',
                    message: `Successfully deleted ${address.name}: ${
                      deletedRow?.name ? deletedRow?.name : deletedRow?.id
                    }`,
                  });
                  setOpenConfirmDialog(false);
                })
                .catch((e: any) => {
                  console.log(e);

                  toaster.show({
                    icon: 'error',
                    message: `Error: Unable to delete ${address.name}: ${
                      deletedRow?.name ? deletedRow?.name : deletedRow?.id
                    }`,
                    intent: 'danger',
                  });
                });
            }}
            autoFocus
          >
            Delete
          </MUIButton>
        </DialogActions>
      </Dialog>

      {openedSlidingPane?.row?.id && (
        <SlidingPaneEdit
          schema={openedSlidingPane?.schema}
          id={openedSlidingPane?.row?.id}
          onSubmit={() => {
            fetchVenues();
            setOpenedSlidingPane({});
          }}
          propertiesFromTable={
            openedSlidingPane?.row ? openedSlidingPane?.row : {}
          }
          onClose={(value) => {
            fetchVenues();
            setOpenedSlidingPane({});
          }}
        />
      )}
    </>
  );
};
